/*
 * Copyright © 2018-2023, GlobalVET AB
 *
 * All rights reserved. No part or the whole of this source code and the compiled program
 * may be reproduced, copied, distributed, disseminated to the public, adapted or transmitted
 * in any form or by any means, including photocopying, recording, or other electronic or
 * mechanical methods, without the prior written permission of GlobalVET AB. This source code
 * and the compiled program may only be used for the purposes of GlobalVET AB. This source code
 * and the compiled program shall be kept confidential and shall not be made public or made
 * available or disclosed to any unauthorized person. Any dispute or claim arising out of the
 * breach of these provisions shall be governed by and construed in accordance with the
 * laws of Sweden.
 */

import Params from "../common/Params";
import { ApiPromise } from "../models/ApiPromise";
import { axiosCommon } from "../util/axiosSetup";
import { PaymentMethodRequest } from "../models/payment/PaymentMethodRequest";
import { PaymentMethodResponse } from "../models/payment/PaymentMethodResponse";

export default class PaymentMethodApi {
  private static baseUrl = Params.clinicServiceBaseURL;

  static addPaymentMethod(
    clinicId: string,
    request: PaymentMethodRequest
  ): ApiPromise<PaymentMethodResponse> {
    const url = `${this.baseUrl}/clinics/${clinicId}/payment-methods`;
    return axiosCommon.post(url, request);
  }

  static getPaymentMethodsOfClinic(
    clinicId: string
  ): ApiPromise<PaymentMethodResponse[]> {
    const url = `${this.baseUrl}/clinics/${clinicId}/payment-methods`;
    return axiosCommon.get(url);
  }

  static updatePaymentMethod(
    clinicId: string,
    paymentMethodId: string,
    request: PaymentMethodRequest
  ): ApiPromise<PaymentMethodResponse> {
    const url = `${this.baseUrl}/clinics/${clinicId}/payment-methods/${paymentMethodId}`;
    return axiosCommon.put(url, request);
  }

  static removePaymentMethod(
    clinicId: string,
    paymentMethodId: string
  ): ApiPromise<void> {
    const url = `${this.baseUrl}/clinics/${clinicId}/payment-methods/${paymentMethodId}`;
    return axiosCommon.delete(url);
  }
}
